<div class="test-item-container" *ngIf="existingItemList==false && displayItemGroups==false">
  <div class="filter-section">
    <div class="col-md-8 text-center" [ngClass]="{'text-success':
      success,'text-danger': error}" *ngIf="messageFlag">{{messages}}</div>
    <div class="btn-wrapper">
      <div class="space-between">
        <button mat-flat-button color="" class="preview-btn btn-primary" (click)="openDialogPreview()"
          [disabled]="isNoItem">{{'testId.TabItems.btnPreview' | translate}}</button>
        <button class="btnPrimary vertical-line" (click)="goToItemGroups()" mat-flat-button
          [disabled]="(roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true) || isPublished">
          <span> + {{'testId.TabItems.btnItemGroup' | translate}}</span>
        </button>
      </div>
      <button class="btnPrimary" (click)='goToExistingItemList()' mat-flat-button
        [disabled]="(roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true) || isPublished">
        <span> + {{'testId.TabItems.btnExisting' | translate}}</span>
      </button>
      <button class="btn-warn new-item" mat-flat-button (click)="createNewItem()"
        [disabled]="(roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true) || isPublished">
        <span> + {{'testId.TabItems.btnNewItem' | translate}}</span>
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="group-tags">
        <ng-container *ngFor="let item of allItemGroupList">
          <div class="tag c-pointer" [ngClass]="{'active': item.itemCategoryid == activeItemGroupId}"
            (click)="selectItemGroup(item)">

            <ng-container *ngIf="item.itemCategoryName?.length > 40 then sliceTitle else noSliceTitle">
            </ng-container>

            <ng-template #sliceTitle>
              <div class="text-bold" matTooltipClass="my-custom-tooltip" matTooltip="{{item.itemCategoryName}}"
                matTooltipPosition="above">
                {{item.itemCategoryName | slice: 0:40}}...</div>
            </ng-template>
            <ng-template #noSliceTitle>
              <div class="text-bold">{{item.itemCategoryName }}</div>
            </ng-template>

            <!-- {{item.itemCategoryName}} -->
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div *ngIf="isNoItem && allItemGroupList == undefined" class="data-not-found-container table-container">
    <span>{{'testId.TabItems.noItemMsg' | translate}}</span>
  </div>
  <div *ngIf="isNoItem && allItemGroupList != undefined" class="data-not-found-container table-container">
    <span>{{'testId.TabItems.noItemMsg1' | translate}}</span>
  </div>
  <div class="row" *ngIf="!isNoItem">
    <div class="col-md-12">
      <!-- <div class="group-tags">
        <ng-container *ngFor="let item of allItemGroupList">
          <div class="tag c-pointer" *ngIf="displayItemGroup.length && displayItemGroup.includes(item.itemCategoryid)"
            [ngClass]="{'active': item.itemCategoryid == activeItemGroupId}" (click)="selectItemGroup(item)">
            {{item.itemCategoryName}}
          </div>
        </ng-container>
      </div> -->
      <div class="table-container">
        <table mat-table [dataSource]="matTableDataSource" matSortb #table class="mat-elevation-z8" cdkDropList
          [cdkDropListData]="matTableDataSource" (cdkDropListDropped)="dragAndDropEventHandler($event)">
          <ng-container matColumnDef="itemBankName">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
              {{'testId.TabItems.column1' | translate}}</th>
            <td mat-cell *matCellDef="let row" (click)='navigateToTestDetails(row.itemBankId)'>
              <div class="text-bold">{{row?.itembankdisplayname}}</div>
              <ng-container *ngIf="row?.itemDescription?.length> 40 then
                sliceDesc else nosliceDesc">
              </ng-container>
              <ng-template #sliceDesc>
                <div matTooltipClass="my-custom-tooltip" matTooltip="{{row?.itemDescription}}"
                  matTooltipPosition="above"> {{row?.itemDescription |
                  slice: 0:40}}... </div>
              </ng-template>
              <ng-template #nosliceDesc>
                <div> {{row?.itemDescription}} </div>
              </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="itemGroup">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
              {{'testId.TabItems.column2' | translate}}</th>
            <td mat-cell *matCellDef="let row">
              <span *ngIf="row.itemGroupName==='Others'"></span>
              <span *ngIf="row.itemGroupName!=='Others'">{{row.itemGroupName}}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="scoringType">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
              {{'testId.TabItems.column3' | translate}} </th>
            <!-- <td mat-cell *matCellDef="let row">
              <span class="text-bold">{{row.scoringTypeId == 1 ? ScoringTypeNameEnum.OnQuestion : row.scoringTypeId == 3 ? ScoringTypeNameEnum.On180360Degree : ScoringTypeNameEnum.OnOption}}</span>
              <br>{{row.styleGroupName}}
            </td> -->
            <td mat-cell *matCellDef="let row">
              <span class="text-bold">{{row.scoringTypeId == 1 ? ('items.questionScoring' | translate) : row.scoringTypeId == 3 ? ('items.DICSStyle' | translate) :
                ('items.optionScoring' | translate)}}</span>
              <br>{{row.styleGroupName}}
            </td>
          </ng-container>
          <ng-container matColumnDef="itemStatus">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
              {{'testId.TabItems.column8' | translate}}</th>
            <td mat-cell *matCellDef="let row">
              <span *ngIf="row?.itemStatus === 'Published'" class="fa fas
                fa-circle publish" matTooltip="{{'testId.TabItems.statusTooltip.published' | translate}}"
                matTooltipPosition="above">
              </span>
              <span *ngIf="row?.itemStatus === 'Unpublished'" class="glyphicon
                glyphicon-adjust unpublish" matTooltip="{{'testId.TabItems.statusTooltip.unPublished' | translate}}"
                matTooltipPosition="above"></span>
            </td>
          </ng-container>
          <ng-container matColumnDef="updated">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
              {{'testId.TabItems.column5' | translate}}</th>
            <td mat-cell *matCellDef="let row">
              <div class="text-bold">{{row.modifiedByUserName}}</div>
              <div>{{row.modifiedDate | dateAgo}}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="tags">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
              {{'testId.TabItems.column6' | translate}}</th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row.tagdescriptionString?.length > 40; then sliceTitle; else noSlice ">
              </ng-container>

              <ng-template #sliceTitle>
                <div matTooltipClass="my-custom-tooltip" matTooltip="{{row?.tagdescription}}" matTooltipPosition="above"
                  class="description-text">
                  <span [innerHtml]="(row.tagdescription | boldTag)"></span>
                </div>
              </ng-template>
              <ng-template #noSlice>
                <span [innerHtml]="(row.tagdescription | boldTag)"></span>
              </ng-template>
              <!-- <span [innerHtml]="(row.tagdescription | boldTag)"></span> -->
            </td>
            <!-- <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row.tagdescription.length> 2 then sliceDesc
                else nosliceDesc"></ng-container>
              <ng-template #sliceDesc>
                <div class="tag-data">
                  <table>
                    <tr>
                      <td *ngIf="row.tagdescription.length> 40" [innerHtml]="(row.tagdescription | boldTag | slice:
                        0:44)+'...'" matTooltipPosition="above" [matTooltip]="row?.tagdescription"></td>
                      <td *ngIf="row.tagdescription.length <40 ||
                        row.tagdescription.length==40" [innerHtml]="row.tagdescription | boldTag"></td>
                    </tr>
                  </table>
                </div>
              </ng-template>
              <ng-template #nosliceDesc>
                <table>
                  <tr>
                    <td class="display-wrap" *ngIf="row.tagdescription.length>
                      40" [innerHtml]="(row.tagdescription | boldTag | slice:
                      0:44)+'...'" matTooltipPosition="above" [matTooltip]="row?.tagdescription"></td>
                    <td class="display-wrap" [matTooltip]="row?.tagdescription" matTooltipPosition="above" *ngIf="row.tagdescription.length <40 ||
                      row.tagdescription.length==40" [innerHtml]="row.tagdescription | boldTag">
                    </td>
                  </tr>
                </table>
              </ng-template>
            </td> -->
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'testId.TabItems.column7' | translate}}</th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button (click)="openInstructionDialog(row)"
                [ngClass]="{disableIcon : isPublished || (roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true)}"
                matTooltip="{{'testId.TabItems.toolTip.settings' | translate}}">
                <mat-icon>settings</mat-icon>
              </button>
              <button mat-icon-button (click)="openConfirmationDialog(row)"
                [ngClass]="{disableIcon : isPublished || (roleSer.accessData? !roleSer.accessData.deleteAllowed:true)}"
                matTooltip="{{'testId.TabItems.toolTip.delete' | translate}}">
                <mat-icon>delete_outline</mat-icon>
              </button>


              <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="openInstructionDialog(row)"
                  [disabled]='isPublished || (roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true)'>
                  <mat-icon>settings</mat-icon>
                  <span>{{'testId.TabItems.toolTip.settings' | translate}}</span>
                </button>
                <button mat-menu-item (click)="openConfirmationDialog(row)"
                  [disabled]="isPublished || (roleSer.accessData? !roleSer.accessData.deleteAllowed:true)">
                  <mat-icon>delete_outline</mat-icon>
                  <span>{{'testId.TabItems.toolTip.delete' | translate}}</span>
                </button>
              </mat-menu> -->
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" cdkDrag [cdkDragData]="row">
            <div class="drag-box" *cdkDragPreview>
              {{row.itemBankName}}
            </div>
          </tr>
        </table>

        <div class="no-records-found" *ngIf="this.tablePageConfig.length === 0">
          {{'testId.TabItems.NoRecord' | translate}}
          </div>
      </div>
      <!-- <div class="item-paginator" *ngIf="showPaginator > 0"
        [ngClass]="[isNoItem? 'checkedClass' : 'uncheckedClass']">
        <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons (page)="onPageChange($event)"></mat-paginator>
      </div> -->
      <div class="item-paginator" [ngClass]="{'hidden': showPaginator === false}">
        <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons
          (page)="onPageChange($event)"></mat-paginator>
      </div>
    </div>
  </div>
</div>

<div class="item-bank-list-container" *ngIf="existingItemList">
  <app-tests-existing-items (closeExistingItemEvent)='closeExistingItem()' [existingItemData]="exitingItemData"
    [itemGroupList]="itemGroupList" [selectedGroup]="selectedItemGroup"></app-tests-existing-items>
</div>

<app-test-preview #appTestPreview></app-test-preview>

<app-item-group-list *ngIf="displayItemGroups" (closeExistingItemEvent)='closeItemGroup()'
  [testUUID]="testUUID"></app-item-group-list>
